<template>
    <div class="app">
        <Navigation />
        <main v-if="song">

            <div class="app__title">
                <div class="app__title__song">
                    <h1>{{ song.title }}</h1>
                    <h2>{{ song.artist }}</h2>
                </div>

                <div class="app__title__actions">

                    <button class="button button--green" v-if="changesMade && isMySong" @click="saveSong()">Save changes</button>

                    <button @click="addGearModal()" v-if="isMySong" class="button button--icon" v-b-tooltip.hover title="Add gear">
                        <i class="las la-plus"></i>
                    </button>

                    <b-dropdown class="song__item__options" toggle-class="button button--icon" :id="'gearItemDropdown-'+song.id" no-caret>
                        <template #button-content>
                            <i class="las la-ellipsis-v"></i>
                        </template>
                        <b-dropdown-item>Share</b-dropdown-item>
                        <b-dropdown-item v-if="currentUser">Copy to my songs</b-dropdown-item>
                        <b-dropdown-item v-if="isMySong">Edit</b-dropdown-item>
                        <b-dropdown-item v-if="isMySong" @click="deleteSong()">Delete</b-dropdown-item>
                    </b-dropdown>
                </div>

            </div>

            <draggable v-model="song.gear" handle=".handle" @change="changesMade = true">
                <div v-for="gear in song.gear" :key="gear.gearId" class="gear__knobs">
                    
                    <i v-if="isMySong" class="handle las la-grip-lines"></i>
                    
                    <div class="gear__knobs__image">
                        <GearImage  :gearId="gear.gearId" />
                    </div>

                    <div class="gear__knobs__knobs" v-if="gear.knobs.length">
                        <Knob v-for="knob in gear.knobs" :key="knob.id" :edit="isMySong" :gearId="gear.gearId" :knobId="knob.id" :value="knob.value" @updateValue="updateValue" />
                    </div>

                    <div class="gear__knobs__actions">
                        <button class="button button--ghost button--icon" @click="removeGear(gear.gearId)" v-if="isMySong">
                            <i class="las la-trash-alt"></i>
                        </button>
                    </div>

                </div>
            </draggable>

            <div class="overlay" v-if="showAddGearModal">
                <div class="overlay__holder">
                     <div class="overlay__title">
                        <strong>Add gear to song</strong>
                        <div class="overlay__close" @click="showAddGearModal = false">&times;</div>
                    </div>
                    <div class="overlay__content">
                        <ul class="m-0 p-0" v-if="user">
                            <li class="gear__select" v-for="(gear, index) in userGear" :key="index">
                                <label>
                                    <input type="checkbox" v-model="newGear" name="gear" :value="gear.gearId" />
                                    <div class="gear__select__image">
                                        <GearImage :gearId="gear.gearId" />
                                    </div>
                                    <GearTitle :gearId="gear.gearId" />
                                </label>
                            </li>
                        </ul>
                    </div>
                    <div class="overlay__footer" v-if="newGear.length">
                        <button class="button" @click="addGear()">Add</button>
                    </div>
                </div>
            </div>

        </main>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Navigation from "@/components/Nav";
import GearTitle from './GearTitle.vue';
import Knob from './Knob.vue';
import draggable from 'vuedraggable'
import GearImage from './GearImage.vue';

export default {
    name: "SongDetail",
    components: { draggable, Navigation, GearTitle, Knob, GearImage },
    data() {
        return {
            changesMade: false,
            showAddGearModal: false,
            newGear: []
        }
    },
    computed: {
        ...mapState(['currentUser', 'user', 'songs', 'gear', 'mySongs']),
        isMySong() {
            if(this.currentUser) {
                return this.currentUser.uid === this.song.author
            }
            return false
        },
        userGear() {
            if(this.currentUser) {
                return this.user.gear.filter((gear) => {
                    var found = this.songGear.find((item) => item.id === gear.gearId)
                    if(found == null || found === undefined) return gear
                })
            }
            return false
        },
        song() {
            var song
            if(this.mySongs.length) {
                song = this.mySongs.find(song => song.id === this.$route.params.id)
                return song
            }
            else {
                song = this.songs.find(song => song.id === this.$route.params.id)
                
            }
            return song
        },
        songGear() {
            var songGear = this.song.gear.map(item => {
                var gearItem =  this.gear.find((gear) => gear.id === item.gearId)
                return gearItem
            })
            return songGear
        }
    },
    methods: {
        addGear: function() {
            var gear = this.song.gear.slice()
            console.log(gear)
            for(var i=0; i<=this.newGear.length-1; i++) {
                var found = this.gear.find((item) => {
                    return item.id === this.newGear[i]
                })
                var knobs = found.knobs

                this.newGear[i] = { gearId : this.newGear[i], knobs: [] }
                if(knobs) {
                    for(var k=0; k<=knobs.length-1;k++) {
                        this.newGear[i].knobs[k] = {
                            id: knobs[k].id,
                            value: null
                        }
                    }
                }

                gear.push(this.newGear[i])
            }
            
            this.$store.dispatch('updateSongGear', { id: this.song.id, gear: gear })
            this.newGear = []
            this.showAddGearModal = false
        },
        addGearModal: function() {
            this.showAddGearModal = true
        },
        saveSong: function(){
            this.$store.dispatch('updateSongKnobs', this.song)
            this.changesMade = false
        },
        deleteSong: function(){
            this.$store.dispatch('deleteSong', this.$route.params.id)
            this.$router.push("/songs")
        },
        removeGear: function(gearId){
            var index = this.song.gear.findIndex(gear => gear.gearId === gearId)
            var gear = [...this.song.gear]
            gear.splice(index, 1)
            this.$store.dispatch('updateSongGear', { id: this.song.id, gear: gear })
        },
        updateValue: function(value){
            var gear = this.song.gear.find((gear) => gear.gearId === value.gearId)
            var knob = gear.knobs.find((knob) => knob.id === value.knobId)
            knob.value = value.value
            this.changesMade = true
        }
    }
}
</script>